import { PRICES } from "../../../utils/constants"
import Input from "../../Input"

const PriceChannels = ({ values, serverData }) => {
    return (
        <div className="mx-14 h-[60%]">
            <h6 className="flex justify-center">چنل های ارز</h6>
            <div class="list flex-grow mt-5">
                <table>
                    <thead className="list-header">
                        <tr>
                            <th className="w-[5%]">ردیف</th>
                            <th className="w-[25%]">اسم</th>
                            <th className="w-[20%]">ایدی چنل</th>
                            <th className="w-[40%]">فرمت</th>
                        </tr>
                    </thead>
                    <tbody>
                        {PRICES.map((item, index) => (
                            <tr>
                                <td>{index + 1}</td>
                                <td>{item.fa}</td>
                                <td>
                                    <Input
                                        type="number"
                                        name={`priceChannels-${item.en}-id`}
                                        options={serverData?.channelList}
                                        dir="ltr"
                                        defaultValue={values ? values[item.en]?.id : null}
                                    />
                                </td>
                                <td>
                                    <Input
                                        type="text"
                                        name={`priceChannels-${item.en}-format`}
                                        dir="ltr"
                                        defaultValue={values ? values[item.en]?.format : null}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>متغیرها:</span>
                <div dir="ltr">
                    <div>%p: قیمت</div>
                </div>
            </div>
        </div>
    )
}

export default PriceChannels
